<div *ngFor="let question of result?.questions" class="form-row">
    <app-question *ngIf="hasControls()" [spacing]="'vmt-2'" [question]="question" [form]="uikitForm"
        class="w-100 px-1" [uiTaggingKey]="'almost_done'" (onChange)="onControlChanges($event)">
    </app-question>
</div>
<div *ngIf="loading" class="text-center w-100 mt-5 spinner-area">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</div>